import { render } from "./ContactsPage.vue?vue&type=template&id=76e862e1"
import script from "./ContactsPage.vue?vue&type=script&lang=js"
export * from "./ContactsPage.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__